import { render, staticRenderFns } from "./SollAcademy.vue?vue&type=template&id=6e51b6aa&scoped=true"
import script from "./SollAcademy.vue?vue&type=script&lang=js"
export * from "./SollAcademy.vue?vue&type=script&lang=js"
import style0 from "./SollAcademy.vue?vue&type=style&index=0&id=6e51b6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51b6aa",
  null
  
)

export default component.exports